var SizeAlias;
(function (SizeAlias) {
    SizeAlias["none"] = "none";
    SizeAlias["line"] = "line";
    SizeAlias["xs"] = "xs";
    SizeAlias["sm"] = "sm";
    SizeAlias["base"] = "base";
    SizeAlias["md"] = "md";
    SizeAlias["lg"] = "lg";
    SizeAlias["xl"] = "xl";
    SizeAlias["xxl"] = "xxl";
})(SizeAlias || (SizeAlias = {}));
function buildSizeScale({ increment, unit, count }) {
    const sizes = {};
    /* eslint-disable-next-line no-plusplus */
    for (let i = 0; i <= count; i++) {
        const value = i * increment;
        sizes[i] = `${value}${unit}`;
    }
    return sizes;
}
export const sizeScale = buildSizeScale({ increment: 0.25, unit: 'rem', count: 20 });
export const sizeAliases = {
    [SizeAlias.none]: '0',
    [SizeAlias.line]: '1px',
    [SizeAlias.xs]: sizeScale[1],
    [SizeAlias.sm]: sizeScale[2],
    [SizeAlias.base]: sizeScale[4],
    [SizeAlias.md]: sizeScale[6],
    [SizeAlias.lg]: sizeScale[8],
    [SizeAlias.xl]: sizeScale[12],
    [SizeAlias.xxl]: sizeScale[16],
};
export const sizes = Object.assign(Object.assign({}, sizeAliases), sizeScale);
//# sourceMappingURL=sizes.js.map